import { Injectable } from '@angular/core';
import { Adaptor } from '../interface/adaptor';
import { AdaptedInformation, Information} from '../interface/information';

@Injectable({
  providedIn: 'root'
})
export class AuthapiAdaptorService implements Adaptor <Information, AdaptedInformation> {

 

  adapt(data: Information):AdaptedInformation{
    return{
      message:data.message,
      token:data.token,
      email:data.user.email,
      firstName:data.user.firstName
    }
  }
}
